import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons, Table } from '@/js/libs/ui';

import type { UploadFile } from './types.ts';

type UploadFileRowProps = {
  uploadFile: UploadFile;
  onDelete: (uploadFile: UploadFile) => void;
  uploading: boolean;
};

export const UploadFileRow: React.FC<UploadFileRowProps> = React.memo(function UploadFileRow({ uploadFile, onDelete, uploading }) {
  const [t] = useTranslation(['backend', 'common']);

  const handleDelete = useCallbackRef(() => {
    onDelete(uploadFile);
  });

  return (
    <Table.Tr>
      <Table.Td>{uploadFile.file.name}</Table.Td>
      <Table.Td type='action'>
        <Table.ActionsList isLoading={uploading}>
          <Table.ActionsListItem onClick={handleDelete} remove icon={<Icons.Trash />}>
            <div>{t('common:DELETE')}</div>
          </Table.ActionsListItem>
        </Table.ActionsList>
      </Table.Td>
    </Table.Tr>
  );
});
